/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import React from 'react';

export type CaptionEntry = {
  speaker: string;
  text: string;
  ts: number;
};

export interface CaptionFeedItem {
  id: string;
  speaker: string;
  text: string;
  timestamp: number;
}

export type CaptionContextState = {
  feed: CaptionFeedItem[];
  captionLine: string;

  /**
   * Whether captions are currently visible.
   */
  captionsEnabled: boolean;

  addCaption: (c: CaptionEntry) => void;
  clearCaptions: () => void;

  /**
   * Toggle captions on/off.
   */
  toggleCaptions: () => void;

  /**
   * Explicitly enable/disable captions.
   */
  setCaptionsEnabled: (enabled: boolean) => void;
};

/**
 * @example
 * const {
 *   feed,
 *   captionLine,
 *   captionsEnabled,
 *   addCaption,
 *   clearCaptions,
 *   toggleCaptions,
 * } = React.useContext(CaptionContext);
 */
export const CaptionContext = React.createContext<CaptionContextState | null>(null);
